module.exports = __webpack_public_path__ + "static/media/ux-ui-designer-senior.d6ae90eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vacancies/ux-ui-designer-senior.jpg
// module id = 358
// module chunks = 0